import React, { useState } from 'react';
import Header from './Header';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Layout = ({ children, onSignOut }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Container className='layout'>
      <Header toggleSidebar={toggleSidebar} onSignOut={onSignOut} />
      {children}
    </Container>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
  onSignOut: PropTypes.func,
};

export default Layout;